import React from 'react';

interface PartnerPlaceholderProps {
  name: string;
  className?: string;
}

const PartnerPlaceholder: React.FC<PartnerPlaceholderProps> = ({ name, className = "" }) => {
  // Generate initials from partner name
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .substring(0, 3)
      .toUpperCase();
  };

  const initials = getInitials(name);

  return (
    <div className={`flex items-center justify-center bg-gradient-to-br from-primary/10 to-secondary/10 rounded-lg border-2 border-dashed border-primary/20 ${className}`}>
      <span className="text-primary font-semibold text-lg">
        {initials}
      </span>
    </div>
  );
};

export default PartnerPlaceholder;